<div class="row justify-content-center">
  <div class="col-lg-8">
    <h2 class="information-card-row__title" *scText="title()"></h2>
    @if (isContentEditorActive || content()?.value) {
      <div class="information-card-row__content" *scText="content()!"></div>
    }
  </div>
</div>
<div class="card-grid" [attr.data-cards]="cards().length">
  @for (card of cards(); track card.id) {
    <wl-information-card
      [title]="card.title"
      [content]="card.content"
      [image]="card.image"
      [button]="card.button"
      [aspectRatio]="aspectRatio()"
    />
  }
</div>
